// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1Y7ln","container":"styles_container__1hB1Q","title":"styles_title__2stZL","wrapper":"styles_wrapper__613DF","answer":"styles_answer__3NOZd"};